import React, { Component } from 'react';
import ImgsViewer from 'react-images-viewer'
import {_} from 'underscore'
import { Container } from 'react-bootstrap';
// import flickr from './flickr'
// import { Storage } from 'aws-amplify';
import AWS from 'aws-sdk'

class S3Lightbox extends Component {
    state = { 
        imgs:[],
        currImg:0,
        isOpen: true,
        searchKey: this.props.searchKey
    }
    componentDidMount() {
        let baseUrl='https://geomgallery.s3-us-west-2.amazonaws.com/' //https://geomgallery.s3-us-west-2.amazonaws.com/NewYork/DSCF9038.jpg
        AWS.config.update({
            accessKeyId:'AKIAYLFZLRWHWYLWU5MW',
            secretAccessKey:'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',
            region: 'us-west-2'
        })
        let s3 = new AWS.S3()
        let params ={
            Bucket: 'geomgallery',
            Delimiter:'',
            Prefix: `${this.state.searchKey}/`,
            MaxKeys: 1000
        }
        // let forPrintout={}
        let listPromise=s3.listObjectsV2(params).promise()
        listPromise
        .then(data=>{
            console.log(data)
            if (data.Contents.length>0) {
                let imgList=_.chain(data.Contents).map((img, i)=>{
                    if (img.Size>1) {
                        return {src: baseUrl + img.Key, thumbnail: baseUrl + img.Key}
                    } else {
                        return {}
                    }

                }).reject((o)=>_.isEmpty(o)).value()
                this.setState({imgs:imgList, isOpen:true})
                console.log(imgList)
            }
            // console.log(data)
            // forPrintout=data
        })
        .catch(console.log)
    }
    openImgsViewer = (index, event) => {
        event.preventDefault()
        this.setState({
            currImg: index,
            isOpen: true,
        })
        }
    closeImgsViewer = () => {
        this.setState({
            currImg: 0,
            isOpen: false,
        })
    }
    gotoPrev = () => {
        this.setState({
            currImg: this.state.currImg - 1
        })
    }
    gotoNext = () => {
        this.setState({
            currImg: this.state.currImg + 1
        })
    }
    gotoImg = (index) => {
        this.setState({
            currImg: index
        })
    }
    thumbClickHandler= () => {

    }
    handleClickImg =()=> {
        if (this.state.currImg === this.props.imgs.length - 1) return
        this.gotoNext()
    }
    render() { 
        
        return ( 
            <Container style={{paddingTop:'80px'}}>
                { this.state.imgs.length>0 ? 
                (<ImgsViewer
                    imgs={this.state.imgs}
                    currImg={this.state.currImg}
                    backdropCloseable={true}
                    isOpen={this.state.isOpen}
                    showThumbnails={true} 
                    onClickThumbnail={this.gotoImg}
                    onClickPrev={this.gotoPrev}
                    onClickNext={this.gotoNext}
                    onClose={this.closeImgsViewer}
                />)
                : null}
            </Container>
         );
    }
}


export default S3Lightbox;